import React from "react";
import Product from "../product/Product";
import {getProductListSlidePerView, IsLP_MP_SP} from "my-styles/media/media";
import TitleHeader from "../product/TitleHeader";
import SwiperCore, {Navigation} from "swiper";
import {Swiper, SwiperSlide} from "swiper/react";
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'

SwiperCore.use([Navigation])

export default function TitleProductList(props) {

    let header = props.header
    let products = props.products

    function getLargeList() {
        let hasRelated = props.data && props.data.related_lines && props.data.related_lines.length > 0
        return (<div className="titleProductList">
            <TitleHeader onAllClicked={props.onAllClicked} header={header}/>
            {(products && products.length) > 0 &&
            <div>
                <Swiper
                    dir="rtl"
                    slidesPerView={getProductListSlidePerView(hasRelated, "1")}
                    spaceBetween={10}
                    navigation={true}
                    modules={[Navigation]}>
                    {products.map((product) => {
                        return <SwiperSlide key={product.product_id} className="marginSmall">
                            <div className="titleProduct">
                                <Product {...props} data={product}/>
                            </div>
                        </SwiperSlide>
                    })}
                    <SwiperSlide style={{width: "1em"}}/>
                </Swiper>
            </div>
            }
        </div>)
    }

    function getSmallList() {
        return (<div className="fullHeight">
            <TitleHeader header={header} onAllClicked={props.onAllClicked}/>
            <div className="titleProductList HScrollInMobile">
                <div className="horizontalScreen">
                    {products.map((product, index) => {
                        return <div key={index} className="titleProduct">
                            <Product {...props} data={product}/>
                        </div>
                    })}
                </div>
            </div>
        </div>)
    }

    if (IsLP_MP_SP()) {
        return getLargeList()
    } else {
        return getSmallList()
    }

}